// Temporary snapshot of DAWA's /postnumre (DAWA closed 1 October 2026) until we read them from Datafordeleren.
import zipCodeData from './zip-codes.json';

export interface ZipCode {
  zipCode: string;
  city: string;
}

export const zipCodes: ZipCode[] = zipCodeData;
